module.exports = __webpack_public_path__ + "d58fad703f1ae64115b3116d61931d1f.png";